'use client'




import Script from 'next/script'

export const GoogleAnalytics = () => {
  const gaId = 'G-XF9QZRCRLE'


  if (!gaId) return null

  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`}
        strategy='afterInteractive'
        rel='preconnect'
      />
      <Script
        id='ga4'
        strategy='afterInteractive'
        rel='preconnect'
        crossOrigin='anonymous'
        dangerouslySetInnerHTML={{
          __html: `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${gaId}');
        `,
        }}
      />
    </>
  )
}
